import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createNotivue, push } from "notivue";
import LogPlugin, { logger } from "@/services/logger/log";

import "notivue/notifications.css";
import "notivue/notifications-progress.css";
import "notivue/animations.css";
import "./assets/tailwind.css";

// Importe e registre o componente
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import OneSignalVuePlugin from "@onesignal/onesignal-vue3";

// Adicione o faCogs à biblioteca
library.add(faEdit, faTrash, faCheck, faTimes, faCogs);
const app = createApp(App);

app.use(LogPlugin);

// OneSignal só é liberado pelo dashboard para o domínio do catálogo do cliente.
// Inicializar em rotas /admin/* dispara "Can only be used on: https://catalogo.menuus.com.br".
if (!window.location.pathname.startsWith("/admin")) {
  app.use(OneSignalVuePlugin, {
    appId: "4606eb48-32ae-435c-8d78-d5e9213f2a65",
    promptOptions: {
      slidedown: {
        prompts: [
          {
            autoPrompt: true,
            delay: {
              pageViews: 0,
              timeDelay: 0,
            },
            text: {
              actionMessage: "Receber notificações sobre promoções e novidades?",
              acceptButton: "Sim",
              cancelMessage: "Não",
            },
            type: "push",
          },
        ],
      },
    },
    notifyButton: {
      prenotify: true,
      enable: true,
      offset: {
        bottom: 10,
        left: 10,
      },
      size: "medium",
    },
    serviceWorkerPath: "/onesignal/sw.js",
  });
}

app.component("FontAwesomeIcon", FontAwesomeIcon);
app.config.warnHandler = (msg, instance, trace) => {
  // Sanitiza dados do Vue para evitar problemas de serialização
  const cleanTrace = typeof trace === "string" ? trace : String(trace || "");
  logger.warn(`[Vue warn] ${msg}`, {
    type: "vue_warning",
    trace: cleanTrace.substring(0, 500), // Limita tamanho do trace
  });
};

app.config.errorHandler = (err, instance, info) => {
  // Sanitiza dados do erro para evitar problemas de serialização
  const errorMessage = err?.message || String(err);
  const errorStack = err?.stack || "";

  logger.error(`[Vue error] ${errorMessage}`, {
    type: "vue_error",
    info: String(info || ""),
    stack: errorStack.substring(0, 1000), // Limita tamanho do stack
  });
};

const notivue = createNotivue({
  notifications: {
    global: {
      zIndex: 9999,
    },
  },
});
app.use(router);
app.use(store);
app.use(notivue);

store.dispatch("auth/login").catch((error) => {
  console.error("Falha ao obter token inicial:", error);
});
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
});
app.mount("#app");

export { push };
